import { render, staticRenderFns } from "./termDetails.vue?vue&type=template&id=94b6a792"
import script from "./termDetails.vue?vue&type=script&lang=js"
export * from "./termDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports